import React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  DateField,
  FunctionField,
  FilterButton,
  ExportButton,
  useRecordContext,
} from 'react-admin';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadPdfButton = () => {
  const record = useRecordContext();
  if (!record || !record.download_url) return null;
  return (
    <Button
      size="small"
      startIcon={<DownloadIcon />}
      href={record.download_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      Download PDF
    </Button>
  );
};

const VisionAppPdfRequestList = (props) => {
  const actions = (
    <>
      <FilterButton />
      <ExportButton />
    </>
  );

  return (
    <List {...props} perPage={50} sort={{ field: 'id', order: 'DESC' }} actions={actions}>
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="request_id" label="Request ID" />
        <TextField source="type" label="Type" />
        <TextField source="lang" label="Lang" />
        <TextField source="status" label="Status" />
        <FunctionField
          label="Error"
          render={record => record.error_message || '—'}
          sortable={false}
        />
        <FunctionField
          label="PDF"
          render={record => (record.download_url ? <DownloadPdfButton record={record} /> : '—')}
          sortable={false}
        />
        <DateField source="created_at" label="Created at" showTime />
      </DatagridConfigurable>
    </List>
  );
};

export default VisionAppPdfRequestList;
